// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-content-placeholders/dist/vue-content-placeholders.css
// module id = 426
// module chunks = 0